/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/addRepo/AddRepoPanel.Props" />
import { ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface IAddRepoPanelProps extends IBasePanelContentProps, IShowPanelProps {
    /**
     * Current connection
     */
    connection: ExternalConnection;

    /**
     * Added repositories from the same provider as the connection prop
     */
    reposFromSameProvider?: ExternalGitRepo[];

    /**
     * Type of repository.
     */
    repositoryType: string;

    /**
     * Callback to save the connection
     */
    onSave: (connectionToSave: ExternalConnection) => Promise<ExternalConnection>;

    /**
     * Boolean to specify whether the type of a connection is GitHubApp
     */
    isGitHubApp: boolean;

    /**
     * Optional boolean to render alternate title text for github app acquisition
     */
    isAcquisitionFlow?: boolean;
}
